import { render, staticRenderFns } from "./BomEdit.vue?vue&type=template&id=d72dd08c&"
import script from "./BomEdit.vue?vue&type=script&lang=js&"
export * from "./BomEdit.vue?vue&type=script&lang=js&"
import style0 from "./BomEdit.vue?vue&type=style&index=0&id=d72dd08c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports